import stringToNumber from '../string/string-to-number.js';
import isNumericalString from '../type-check/is-numerical-string.js';
import isString from '../type-check/is-string.js';

/**
 * @func getQueryParams
 * @param {string} searchString - The URL location.search value
 * @return {object}
 * @desc Pulls query params from a URL search string, returning an object. This will not properly transform array or object values, only strings, numbers, and booleans.
 * ```js
 * getQueryParams('?active=true&name=pete&pageSize=25');
 * // returns { active: true, name: 'pete', pageSize: 25 }
 * ```
 * @memberof module:Navigation
 * @instance
 */
const ignoreNumerical = ['zip', 'zipCode'];
function getQueryParams(searchString) {
    if (!isString(searchString))
        return searchString;
    const entries = new URLSearchParams(searchString).entries();
    return [...entries].reduce((hash, item) => {
        const [key, value] = item;
        let parsedValue = value;
        if (isNumericalString(value) && !ignoreNumerical.includes(key)) {
            parsedValue = Number(stringToNumber(value));
        }
        else if (value === 'false') {
            parsedValue = false;
        }
        else if (value === 'true') {
            parsedValue = true;
        }
        return Object.assign(Object.assign({}, hash), { [key]: parsedValue });
    }, {});
}

export { getQueryParams as default };
